import React from 'react'
import "./HomePage.css"
import Taskbar from '../taskbar/taskbar'



function HomePage() {
  return <div className='body'>
    <div className="taskbar">
      <Taskbar />
    </div>
            <div className='title'>
            <p>AMMANAMANCHI RAVISANKAR BHARADWAJ</p>
            <div className='subtitle'>Learn , Eat ,Code ,Sleep ,Wake up,Repeat()</div>
            </div>

          </div>
 

  
}

export default HomePage